import chevronDown from '@iconify/icons-ic/baseline-keyboard-arrow-down';
import * as RadixAccordion from '@radix-ui/react-accordion';
import type { ReactNode } from 'react';
import { Icon } from '../icon/Icon';
import { Text } from '../text/Text';

type ExpandableListItemProps = {
  value: string;
  title: string;
  label?: string;
  children: ReactNode;
};

export function ExpandableListItem({
  value,
  title,
  label,
  children,
}: ExpandableListItemProps) {
  return (
    <RadixAccordion.Item
      value={value}
      className="data-[state=open]:border-b data-[state=open]:border-border-minimal-enabled data-[state=open]:gap-4 data-[state=open]:pb-2"
    >
      <RadixAccordion.Header className="data-[state=closed]:border-b data-[state=closed]:border-border-minimal-enabled data-[state=closed]:h-[58px] data-[state=open]:h-[50px]">
        <RadixAccordion.Trigger className="group flex w-full items-center justify-between gap-4 h-[58px]">
          <div className="flex items-center gap-3 justify-between w-full">
            <Text className="font-medium group-data-[state=open]:text-content-primary-brand group-data-[state=closed]:text-content-body">
              {title}
            </Text>

            {label && (
              <div className="bg-support-success-light text-support-success-bold  font-bold text-sm py-1 px-4 rounded-full">
                {label}
              </div>
            )}
          </div>

          <Icon
            icon={chevronDown}
            size={24}
            className="transition-transform group-data-[state=open]:rotate-180 text-action-primary-enabled font-bold"
          />
        </RadixAccordion.Trigger>
      </RadixAccordion.Header>

      <RadixAccordion.Content className="overflow-hidden">
        {children}
      </RadixAccordion.Content>
    </RadixAccordion.Item>
  );
}
